import { Component, OnInit, AfterViewInit } from '@angular/core';
import { SessionService } from '../../shared/services/session.service';

@Component({
  selector: 'app-fk-rb-index',
  templateUrl: './fk-rb-index.component.html',
  styleUrls: ['./fk-rb-index.component.scss']
})
export class FKRBIndexComponent implements OnInit, AfterViewInit {
  public mydevice: string = "";
  public bloburl: string;
  constructor(private sessionService: SessionService, ) { this.bloburl = this.sessionService.bloburl; }

  ngOnInit() {  
    var isIOS = /iPad|iPhone|iPod/.test(navigator.platform) ||
      (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
    var userAgent = navigator.userAgent.toLowerCase();
    var android_dev = userAgent.indexOf("android") > -1;
    var chrome_browser = userAgent.indexOf("chrome") > -1;
    var samsung_browser = userAgent.indexOf("samsung") > -1;
      if(isIOS)
      {
        this.mydevice = "ipad";
      }
      else if (android_dev) {
        this.mydevice = "android";

        if (samsung_browser) {
          this.mydevice = this.mydevice + "_samsung";
        }
        else if (chrome_browser) {
          this.mydevice = this.mydevice + "_chrome";

        }
        var body = document.body;
        body.classList.add(this.mydevice);
      }
    // $(".sidenav").css('margin-left', "0%");
    // $(".main").css({ "margin-left": "12.5%" });
    // var mainleftmenu = document.getElementById("opennavbutton");
    // mainleftmenu.style.display = "block";
  }
  async ngAfterViewInit() {

  }

  private loadScript(scriptUrl: string) {
    return new Promise((resolve, reject) => {
      const scriptElement = document.createElement('script');
      scriptElement.src = scriptUrl;
      scriptElement.onload = resolve;
      document.body.appendChild(scriptElement);
    })
  }

}
